import React from 'react';
import PropTypes from 'prop-types';

const ZuoraLoading = (props) => {
  if (props.loadingHidden) {
    return null;
  }
  const bgStyle = {
    backgroundColor: '#f2f2f2',
    height: '300px',
    width: '100%',
    textAlign: 'center',
    padding: '50px'
  };
  return (
    <div style={bgStyle}>
      <i className="fa fa-circle-o-notch fa-spin fa-3x fa-fw" /> <span className="sr-only">Loading...</span>
    </div>
  );
};

ZuoraLoading.propTypes = {
  loadingHidden: PropTypes.bool
};

export default ZuoraLoading;



/** WEBPACK FOOTER **
 ** ./src/components/zuora/ZuoraLoading/ZuoraLoading.js
 **/